import { createContainer } from 'unstated-next'
import { useState } from 'react'

export const DrawerContainer = createContainer(() => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  return { drawerOpen, setDrawerOpen }
})
